import React from "react";

export const PremiumBadge = () => {
    return (
        <div className="prem_badge_container">
            <span className="badge prem_badge">Premium</span>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/c/PremiumBadge.js